import React, { useState, useEffect, useRef } from "react";
import { Navbar, Nav, Container, NavDropdown } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { getPath } from "../utils/constants";
import LanguageToggle from "./LanguageToggle";
import { useTranslation } from "react-i18next";

// Menu structure data source
const menuData = [
  {
    key: "menu-universe",
    isDropdown: true,
    items: [
      { key: "book-kembar", path: "siKembarPintar" },
      { key: "book-reja", path: "jejakRejakids", disabled: true },
      { key: "book-bira", path: "bira", disabled: true },
      { key: "book-cimi", path: "adventureOfCimiCimo", disabled: true },
      { key: "book-gani", path: "gani", disabled: true },
    ],
  },
  // {
  //   key: "menu-product",
  //   isDropdown: true,
  //   items: [
  //     { key: "menu-story-book", path: "storyBook" },
  //     { key: "menu-activity-book", path: "activityBook", disabled: true },
  //     { key: "menu-animation", path: "animation", disabled: true },
  //     { key: "menu-merchandise", path: "merchandise", disabled: true },
  //   ],
  // },
  {
    title: "Others",
    isDropdown: false,
    items: [
      { key: "menu-about", path: "about" },
      { key: "menu-contact", path: "contact" },
    ],
  },
];

const NavigationBar = () => {
  const location = useLocation(); // Get the current location (URL)
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);
  const [stickyExpanded, setStickyExpanded] = useState(false);
  const [showSticky, setShowSticky] = useState(false);

  useEffect(() => {
    setShowSticky(false);
    setStickyExpanded(false);
  }, [location.pathname]);

  useEffect(() => {
    const showAt = 400;
    const scrollableElement = document.querySelector('.App');

    if (!scrollableElement) {
        return;
    }

    const handleScroll = () => {
      if (scrollableElement.scrollTop > showAt) {
        setShowSticky(true);
      } else {
        setShowSticky(false);
      }
    };

    scrollableElement.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      scrollableElement.removeEventListener("scroll", handleScroll);
    };
  }, []);



  const renderMenuItems = (closeMenu) =>
    menuData.map((menu) => {
      if (menu.isDropdown) {
        const dropdownClassName = menu.items.some((item) => location.pathname.startsWith(getPath(item.path))) ? "active-link-parent" : "";

        return (
          <NavDropdown key={menu.key} title={resolveLabel(menu.key)} id={`${menu.key}-dropdown`} className={dropdownClassName}>
            {menu.items.map((item) => (
              <NavDropdown.Item key={item.key} as={Link} to={getPath(item.path)} onClick={closeMenu} className={[location.pathname === getPath(item.path) ? "active-link" : "", item.disabled ? "disabled-nav" : ""].join(" ")}>
                {resolveLabel(item.key)}
              </NavDropdown.Item>
            ))}
          </NavDropdown>
        );
      }

      return menu.items.map((item) => (
        <Nav.Link key={item.key} as={Link} to={getPath(item.path)} onClick={closeMenu} className={[location.pathname === getPath(item.path) ? "active-link" : "", item.disabled ? "disabled-nav" : ""].join(" ")}>
          {resolveLabel(item.key)}
        </Nav.Link>
      ));
    });

  const resolveLabel = (key) => (key.startsWith("book-") ? t(`${key}.title`) : t(key));
  const closePrimaryMenu = () => setExpanded(false);
  const closeStickyMenu = () => {
    setStickyExpanded(false);
  };

  return (
    <>
      <Navbar expanded={expanded} onToggle={setExpanded} expand="lg" className="bg-white">
        <Container>
          <Navbar.Brand as={Link} onClick={closePrimaryMenu} to={getPath("home")}>
            <img src="../assets/logo.svg" alt="Childreams Logo" className="d-inline-block align-top" />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end">
            <Nav className="ml-auto">
              {renderMenuItems(closePrimaryMenu)}
              <LanguageToggle />
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <Navbar expanded={stickyExpanded} onToggle={setStickyExpanded} expand="lg" fixed="top" className={`sticky-navbar ${showSticky ? "is-visible" : ""}`}>
        <Container>
          <Navbar.Brand as={Link} onClick={closeStickyMenu} to={getPath("home")}>
            <img src="../assets/logo.svg" alt="Childreams Logo" className="d-inline-block align-top" />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="sticky-navbar-nav" />
          <Navbar.Collapse id="sticky-navbar-nav" className="justify-content-end">
            <Nav className="ml-auto">
              {renderMenuItems(closeStickyMenu)}
              <LanguageToggle />
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
};

export default NavigationBar;
